module.exports = "<vb-generic-selection-input\r\n  inputId=\"adminUnit-input\"\r\n  label=\"Administrationseinheit\"\r\n  [control]=\"control\"\r\n  [optional]=\"optional\"\r\n  [styleClass]=\"styleClass\"\r\n  [items]=\"adminUnits\"\r\n  [selectedItem]=\"item\"\r\n  (itemChanged)=\"onItemChangedEvent($event)\">\r\n</vb-generic-selection-input>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/organization/administration_unit/administration-unit-selection/administration-unit-selection.component.html
// module id = ./src/app/organization/administration_unit/administration-unit-selection/administration-unit-selection.component.html
// module chunks = main